<template>
  <div>
      <HeaderIndex></HeaderIndex>
      <div class="w1100">
       	<div class="marginT10">
        	<div class="is-postion fb">
              <div class="is-posbg">您当前的位置： <a href="/">网站首页</a> /
                <span style="color:#F70000;" v-if="contentData.channel">{{contentData.channel.nameChn}}</span>
            	</div>
          </div>
          <div style="border:1px solid #ccc; border-top:none; padding-top:15px;line-height:26px; font-size:12px;text-align:center;padding:20px 0px 20px 0px;" v-if="this.contentData && this.contentData.deleted">内容不存在</div>
          <div style="border:1px solid #ccc; border-top:none; padding-top:15px;" v-else-if="this.contentData.channel">
              <div class="border_l border_r border_b border_ECEAEB">
                  <div style="width:100%; line-height:26px; font-size:20px; font-weight:bold; text-align:center; padding:20px 0px 20px 0px;color: #dc0800;" v-html="this.contentData.title"></div>
                  <div class="titleInfo a5">
                  <span v-if="this.isShowTime">发布时间：{{this.contentData.timePublish.substring(0,10)}}</span>     
                  &nbsp;&nbsp;&nbsp;&nbsp;来源：{{this.contentData.infoSource}}   
                  &nbsp;&nbsp;&nbsp;&nbsp;字体：<a style="font-size:18px;" href="javascript:ContentSize(18)">T</a> <a style=" font-size:15px;" href="javascript:ContentSize(15)">T</a> <a style=" font-size:12px;" href="javascript:ContentSize(12)">T</a>  </div>
                  <div id="BodyLabel" style="padding:20px 40px 40px 40px;line-height:28px; font-size:14px;overflow:hidden;">
                    <div style="width: 640px;margin: 0px auto;" v-if="this.contentData.flv && this.contentData.flv.indexOf('.flv') == -1">
                      <video :src="this.contentData.flv" controls="controls" style="width:100%;width:100%;"></video>
                    </div>
                    <template v-if="this.contentData.content">
                      <div v-html="this.contentData.content"></div>
                    </template>
                    <template v-else-if="this.contentData.flv && this.contentData.flv.indexOf('.flv') > -1">
                      <div style="text-align: center;">浏览器不支持flash播放</div>
                    </template>
                    <template v-else-if="this.contentData.channel && this.contentData.channel.id == 6177 && Date.parse(this.contentData.timeUnpublish) < new Date()">
                      <div style="text-align:center;">干部任前公示已结束</div>
                      <div style="text-align:center;">感谢您的关注</div>
                    </template>
                  </div>
              </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <FooterIndex name="footerIndex"></FooterIndex>
  </div>
</template>


<script>

import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import request from '@/common/request'
import  '../assets/css/css.css'

export default {
  name: 'DetailIndex',
  data () {
    return {
      id:null,
      contentData:{},
      baseOssPath: process.env.OSS_BASE_PATH,
      isShowTime:false,
      //屏蔽发布时间模块
      enableShowTime:[6233,6234,6235,6160,6161,6162,6163]
    }
  },
  components: {
      FooterIndex,HeaderIndex
  },
  mounted() {
    this.id = this.$route.query.id;
    this.initData();
      
    window['ContentSize'] = (size) => {
        this.setContentSize(size);
     };
  },
  watch: {
    $route(to, from){
      this.id = this.$route.query.id;
      this.initData();
    }
  },
  methods: {
    initData:function(){
      this.getContentDetail().then(data=>{
        if(data.result && data.errorCode == 0){
          this.contentData = data.result;
          this.contentData.content = this.imgSrcReplace(this.contentData.content);
          //是否显示发布时间，TODO 后台管理加选项，由后台设置较合理
          debugger;
          if(data.result && data.result.channel){
            if(this.enableShowTime.indexOf(data.result.channel.id) == -1){
              this.isShowTime = true;
            }
          }
        }else{
          this.contentData = {};
        }
      });
    },
    getContentDetail:function(){
      if(this.id){
        return request({
          url: '/index/getContentById',
          method: 'get',
          params: { 
            "id":this.id
          }
        })
      }else{
        return request({
          url: '/manage/getReviewCache',
          method: 'get',
          params: {
          }
        })
      }
    },
    setContentSize:function(size){
        var obj=document.getElementById('BodyLabel');obj.style.fontSize=size+'px';
    },
    imgSrcReplace:function(htmlstr) {
      if(!htmlstr){
        return htmlstr;
      }
      let that = this;
      let regex3 = new RegExp(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi);
      let htmlstr1 = htmlstr.replace(regex3, function (match, capture) {
        var baseImagePath = that.baseOssPath+"/qsxfoldfile/";
        debugger
        if(capture.indexOf(baseImagePath) == -1 && capture.indexOf("http://") == -1 && capture.indexOf("https://") == -1 && capture.indexOf("www.") == -1 && capture.indexOf(that.baseOssPath) == -1){
          // capture =  baseImagePath + capture;
          return match.replace(capture,baseImagePath + capture);
        }
        // var newStr = "<img src=" + capture + ' alt="" />';
        return match;
      });
      regex3 = null;
      return htmlstr1;
    }
  }
}
</script>

<style scoped>
.titleInfo{ width:100%; clear:both; height:30px; line-height:30px; text-align:center; font-size:12px; border-bottom:1px dashed #cccccc; color:#666666; }
</style>



// WEBPACK FOOTER //
// src/components/DetailIndex.vue